var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('log-table',{attrs:{"logs":_vm.logs,"loading":_vm.loadingLogs},on:{"get-logs":_vm.getLogs}})
}
var staticRenderFns = []

export { render, staticRenderFns }